export enum ColumnId {
  AccountId = 'accountId',
  GrossProfit = 'grossProfit',
  LastInvoiceDate = 'lastInvoiceDate',
  LineItems = 'lineItems',
  Name = 'name',
  RealizedGrossMargin = 'realizedGrossMargin',
  Revenue = 'revenue',
  SalesRep = 'salesRep',
  WeeklyEditsGrossProfitImpact = 'weeklyEditsGrossProfitImpact',
}

export enum DetailColumnId {
  Checkbox = 'checkbox',
  CostDelta = 'costDelta',
  CurrentCost = 'currentCost',
  CurrentMargin = 'currentMargin',
  CurrentPrice = 'currentPrice',
  EditsGrossProfitImpactPerOrder = 'editsGrossProfitImpactPerOrder',
  GrossProfitPerUnit = 'grossProfitPerUnit',
  ItemCode = 'itemCode',
  LastCost = 'lastCost',
  LastPrice = 'lastPrice',
  MarginDelta = 'marginDelta',
  Name = 'name',
  PriceDelta = 'priceDelta',
  RealizedGrossMargin = 'realizedGrossMargin',
  UOM = 'uom',
  Volume = 'volume',
  VolumePerOrder = 'volumePerOrder',
  WeeklyEditsGrossProfitImpact = 'weeklyEditsGrossProfitImpact',
  WeeklyPurchaseQuantities = 'weeklyPurchaseQuantities',
}
